import classNames from 'classnames';
import styles from './Footer.module.scss';
import {
	Container,
	Grid,
	Logo,
	Icon,
	Link,
	// Paragraph,
} from 'ui/components';
import React from 'react';
import { FooterCard as FooterCardWrapper, FooterCardProps } from './FooterCard';
import { GridCell } from 'ui/components/4-habitats/Grid';
import FacebookIcon from 'ui/icons/facebook-icon.svg';
import LinkedinIcon from 'ui/icons/linkedin-icon.svg';

export interface FooterProps {
	className?: string;
	emailLabel?: string;
	moduleLink?: Umbraco.Link;
	children?: React.ReactNode;
}

const Footer: React.FC<FooterProps> & { Card: React.FC<FooterCardProps> } = ({
	className,
	children,
	// emailLabel,
	// moduleLink
}) => {
	return (
		<footer className={classNames(styles.Footer, className)} role="contentinfo">
			<Container className={styles.Footer_container} width="Standard">
				<Grid className={styles.Footer_inner} wrap={true} container={true}>
					<GridCell mobileWidth="100" desktopWidth="10">
						<article className={styles.Footer_logoWrapper}>
							<Logo withText={false} />
						</article>
					</GridCell>
					{children}
				</Grid>
			</Container>
			<Container width="Standard">
				<Grid className={styles.Footer_containerSoMe} center={true} wrap={true} container={true}>
					<GridCell mobileWidth="100" desktopWidth="10">
						<aside className={styles.Footer_SoMe}>
							<Link className={styles.Footer_SoMeLink} url="https://www.facebook.com/DanskElForbund">
								<Icon className={styles.Footer_SoMeLinkIcon}>
									<FacebookIcon />
								</Icon>
								{/* <Paragraph className={styles.Footer_SoMeLinkText}>Facebook</Paragraph> */}
							</Link>
							<Link className={styles.Footer_SoMeLink} url="https://www.linkedin.com/company/danskelforbund/">
								<Icon className={styles.Footer_SoMeLinkIcon}>
									<LinkedinIcon />
								</Icon>
								{/* <Paragraph className={styles.Footer_SoMeLinkText}>LinkedIn</Paragraph> */}
							</Link>
						</aside>
					</GridCell>
				</Grid>
			</Container>
		</footer>
	);
};

Footer.Card = FooterCardWrapper;

export { Footer };
